module.exports = __webpack_public_path__ + "static/media/granolaBar.671ede66.png";